import EngagementCenter from 'features/engagement/admin/engagement-center';
import React from 'react';

/** /administration/engagement/:tab? — guarded by AdminRoute (platform admins only). */
const AdminEngagementPage: React.FC = () => <EngagementCenter />;

export default AdminEngagementPage;
